module.exports = __webpack_public_path__ + "static/media/DCAU.f1846a4d.png";